<template>
    <div class="card">
        <div class="p-3 pb-0 card-header">
        </div>
        <div class="card-body">
            <div class="d-flex justify-content-center align-items-center" :style="{ height: containerHeight }">
                <div class="text-center">
                    <img 
                        :src="iconSrc" 
                        alt="icon" 
                        :height="iconSize" 
                        :width="iconSize"
                        class="loading-icon"
                    >
                    <h4 class="fw-bold mt-3">{{ message }}</h4>
                    <p v-if="subtitle" class="text-muted mt-2">{{ subtitle }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoadingScreen',
    props: {
        message: {
            type: String,
            default: 'Cargando Información...'
        },
        subtitle: {
            type: String,
            default: 'Esto puede tardar unos segundos.'
        },
        iconSrc: {
            type: String,
            default: require('@/assets/img/allo-icon.svg')
        },
        iconSize: {
            type: [Number, String],
            default: 50
        },
        containerHeight: {
            type: String,
            default: '50vh'
        },
        spinSpeed: {
            type: String,
            default: '1.5s'
        }
    }
}
</script>

<style scoped>
.loading-icon {
    animation: spin v-bind(spinSpeed) linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>